module.exports = __webpack_public_path__ + "assets/img/69_316.ee72f86e.jpg";